__turbopack_context__.v({
  "container": "LayoutComponents-module__XlpC8q__container",
  "content": "LayoutComponents-module__XlpC8q__content",
});
